import { Home, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface PageHeaderProps {
  title: string;
  description?: string;
  breadcrumbs?: Array<{
    label: string;
    path?: string;
  }>;
}

export function PageHeader({ title, description, breadcrumbs = [] }: PageHeaderProps) {
  return (
    <div className="mb-8">
      {/* Breadcrumbs */}
      <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-4">
        <Link
          to="/dashboard"
          className="hover:text-[#4A90C8] transition-colors"
          aria-label="Home"
        >
          <Home className="w-4 h-4" />
        </Link>
        {breadcrumbs.map((crumb, index) => (
          <div key={index} className="flex items-center space-x-2">
            <ChevronRight className="w-4 h-4 text-gray-400" />
            {crumb.path ? (
              <Link
                to={crumb.path}
                className="hover:text-[#4A90C8] transition-colors"
              >
                {crumb.label}
              </Link>
            ) : (
              <span className="text-gray-900 font-medium">{crumb.label}</span>
            )}
          </div>
        ))}
      </nav>

      {/* Page Title */}
      <h1 className="text-4xl font-bold text-gray-900 mb-2">{title}</h1>

      {/* Description */}
      {description && (
        <p className="text-gray-600 text-lg">{description}</p>
      )}
    </div>
  );
}
